<template>
  <div class="row mb-1">
    <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12 px-gap">
      <div
        id="program-stasiun"
        class="widget-12 card card-default widget-loader-circle shade"
      >
        <div class="card-body">
          <div class="row">
            <div class="col-md-12 col-sm-12">
              <div class="pull-left m-t-5 m-b-5">
                <h4 class="m-b-0">Program Stasiun TV</h4>
                <p class="small hint-text">Daftar Program Stasiun TV</p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 col-sm-12">
              <loader-component v-if="is_loading" />
              <div v-else>
                <div
                  v-if="Object.keys(data.series).length == 0"
                  class="alert alert-danger"
                  role="alert"
                  align="center"
                >
                  <strong>Mohon maaf, data tidak tersedia! </strong>
                  <br />
                  Tidak dapat menampilkan grafik dengan data kosong.
                </div>
                <div v-else>
                  <bar-chart-component
                    :dataset="data.series"
                    :yLabel="data.yLabel"
                    barchart_id="barchart-program-tv"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loader_component from "@/views/components/loader.vue";
import bar_chart_highchart from "@/views/components/chart/bar_chart_highchart.vue";

export default {
  name: "medkon_program_stasiun_tv",
  props: {
    is_loading: {
      type: Boolean,
      default: function() {
        return true;
      },
    },
    data: {
      type: Object,
      default: function() {
        return {};
      },
    },
  },
  components: {
    "loader-component": loader_component,
    "bar-chart-component": bar_chart_highchart,
  },
};
</script>
